const currencies = {
  usd: { sign: '$', key: 'usd' },
  eur: { sign: '€', key: 'eur' },
  gbp: { sign: '£', key: 'gbp' },
};

export default currencies;
